<ng-container *ngIf="showDataLoading">
  <hr>
  <div *ngIf="showDataLoading" class="d-flex align-items-center">
    <strong>{{ loadingMessage }}</strong>
    <div class="spinner-border text-success ms-auto" role="status" aria-hidden="true"></div>
  </div>
</ng-container>
